import React from "react";
import { Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer data-section-id="19830" id="geroi-tactical-division" className="dark bg-[#060b13] text-white py-20 md:py-24 relative overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16 mb-16">
          {}
          <div className="flex flex-col items-start">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/efficio_virtual_logo.png" alt="Geroi.eu Logo" className="h-7 mb-6 object-contain brightness-0 invert" />
            <p className="text-[#9ca3af] text-base leading-relaxed max-w-sm font-sans">
              Powered by 10Web. Divisione Tactical Geroi.eu. A premier holding company coordinating strategic portfolios of logistical and digital assets to dominate international markets.
            </p>
          </div>

          {}
          <div className="flex flex-col md:items-start">
            <h3 className="text-xl font-bold mb-6 font-serif tracking-wider uppercase text-white">Navigation</h3>
            <nav className="flex flex-col space-y-4">
              <Link to="/HeroesPage" className="text-[#9ca3af] hover:text-primary transition-colors duration-200 text-base font-sans w-fit">
                Geroi.eu
              </Link>
              <Link to="#" className="text-[#9ca3af] hover:text-primary transition-colors duration-200 text-base font-sans w-fit">
                About
              </Link>
              <Link to="#" className="text-[#9ca3af] hover:text-primary transition-colors duration-200 text-base font-sans w-fit">
                Services
              </Link>
              <Link to="#" className="text-[#9ca3af] hover:text-primary transition-colors duration-200 text-base font-sans w-fit">
                Owned Ventures
              </Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="text-xl font-bold mb-6 font-serif tracking-wider uppercase text-white">Global Operations</h3>
            <div className="flex flex-col space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 mt-1 shrink-0 text-primary" />
                <span className="text-[#e5e7eb] text-base font-sans font-bold">
                  Emergency Logistics: <span className="text-white hover:text-primary hover:drop-shadow-[0_0_8px_rgba(37,99,235,0.8)] transition-all cursor-pointer">253 3337 367</span>
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 shrink-0 text-primary" />
                <span className="text-[#e5e7eb] text-base font-sans font-bold">
                  International Line: <span className="text-white hover:text-primary hover:drop-shadow-[0_0_8px_rgba(37,99,235,0.8)] transition-all cursor-pointer">992 537 9906</span>
                </span>
              </div>
            </div>
            
            {}
            <div className="flex items-center gap-4 mt-8">
              <Link to="#" className="text-[#9ca3af] hover:text-primary transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </Link>
              <Link to="#" className="text-[#9ca3af] hover:text-primary transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </Link>
              <Link to="#" className="text-[#9ca3af] hover:text-primary transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </Link>
              <Link to="#" className="text-[#9ca3af] hover:text-primary transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-primary/30 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#9ca3af] font-sans">
          <p>&copy; {currentYear} Geroi.eu. All rights reserved.</p>
          <p className="font-bold tracking-widest uppercase text-white/40">Divisione Tactical Geroi.eu</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>;
}